import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './css/App.css';
import HomePage from './HomePage';
import { AuthProvider, RequireAuth } from './auth/AuthContext';
import { ClosedAccountPage, ResetPasswordPage, VerifyEmailPage } from './auth/AuthPages';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import { ProtectedLayout } from './layout/ProtectedLayout';
import {
  AccountSettingsRoute,
  CardsRoute,
  ContactRoute,
  DashboardRoute,
  DepositRoute,
  ExchangeRoute,
  TransactionsRoute,
  VerificationRoute,
  WithdrawRoute,
} from './layout/ProtectedPageRoutes';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify" element={<VerifyEmailPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/compte-ferme" element={<ClosedAccountPage />} />

      <Route
        element={(
          <RequireAuth>
            <ProtectedLayout />
          </RequireAuth>
        )}
      >
        <Route path="/dashboard" element={<DashboardRoute />} />
        <Route path="/deposit" element={<DepositRoute />} />
        <Route path="/withdraw" element={<WithdrawRoute />} />
        <Route path="/cards" element={<CardsRoute />} />
        <Route path="/transactions" element={<TransactionsRoute />} />
        <Route path="/exchange" element={<ExchangeRoute />} />
        <Route path="/contact" element={<ContactRoute />} />
        <Route path="/verification" element={<VerificationRoute />} />
        <Route path="/account-settings" element={<AccountSettingsRoute />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function HomeRoute() {
  const navigate = useNavigate();

  return (
    <HomePage
      onLogin={() => navigate('/login')}
      onRegister={() => navigate('/register')}
      onGetStarted={() => navigate('/register')}
    />
  );
}

export default App;
